<template>
    <div style="background-color: #FAFAFA;">
        <div class="resourceLib" v-loading="loading">
            <div class="resourceLib-filter">
                <p class="resourceLib-filter-title">学习资源库</p>
                <div class="resourceLib-filter-box" v-for="(item, obj, index) in filterData" :key="index">
                    <p>{{ index === 0 ? '资源类型' : '适用课程' }}</p>
                    <div v-for="(item2, index2) in item" :key="index2" :style="{
                        background: index === 0 ? (item2 === query.format ? 'linear-gradient(to right, #18676A 0%, #18676A 10%, #1C8577 10%, #1C8577 100%)' : 'transparent') : (item2 === query.course ? 'linear-gradient(to right, #18676A 0%, #18676A 10%, #1C8577 10%, #1C8577 100%)' : 'transparent'),
                        border: index === 0 ? (item2 === query.format ? '1px solid transparent' : '1px solid #666') : (item2 === query.course ? '1px solid transparent' : '1px solid #666'),
                        color: index === 0 ? (item2 === query.format ? '#fff' : '#333') : (item2 === query.course ? '#fff' : '#333')
                    }" @click="changeType(item2, index)">{{ item2 }}</div>
                </div>
            </div>
            <div class="resourceLib-box">
                <div class="resourceLib-box-item" v-for="(item, index) in list" :key="index">
                    <div class="resourceLib-box-item-left">
                        <p class="resourceLib-box-item-left-title">{{ item.name }}</p>
                        <div>
                            <p v-for="(item2, index2) in ['适用学科', '资源格式', '适用课程', '资源大小']" :key="index2">{{ item2 }}：{{ index2 === 0 ? item.discipline : index2 === 1 ? item.format : index2 === 2 ? item.course : Math.round(item.size / 1024 / 1024) < 1 ? Math.round(item.size / 1024) + 'Kb' : Math.round(item.size / 1024 / 1024) + 'Mb' }}</p>
                        </div>
                    </div>
                    <div class="resourceLib-box-item-right">
                        <p>
                            <i class="el-icon-star-off"></i>
                            <b>{{ item.rating ? item.rating : '5.0' }}分</b>
                        </p>
                        <a :href="fileUrl + '/resourcelib/download?id=' + item.id">下载</a>
                        <span>下载次数：{{ item.downloadCount }}</span>
                    </div>
                </div>
                <div class="pagination"><el-pagination v-show="total > 0" background layout="prev, pager, next" :current-page="query.pageNum" :page-size="query.pageSize" :total="total" @current-change="pageChange"></el-pagination></div>
            </div>
        </div>
    </div>
</template>
<script>
import { url } from "../services/url"
import { getResourcelibFilters, listResourcelib } from "../services/services"
export default {
    name: 'ResourceLib',
    data() {
        return {
            fileUrl: url,
            loading: true,
            total: 0,
            query: {
                format: undefined,
                course: undefined,
                pageSize: 4,
                pageNum: 1
            },
            filterData: {
                formats: [],
                courses: []
            },
            list: []
        }
    },
    created() {
        console.clear()
        getResourcelibFilters().then(res => {
            this.filterData.formats = res.data.types
            this.filterData.courses = res.data.courses
            this.getList()
        })
    },
    methods: {
        changeType(val, index) {
            if(index === 0) {
                this.query.format = this.query.format === val ? undefined : val
            }
            if(index === 1) {
                this.query.course = this.query.course === val ? undefined : val
            }
            this.query.pageNum = 1
            this.getList()
        },
        pageChange(e) {
            this.query.pageNum = e
            this.getList()
        },
        getList(){
            this.loading = true
            listResourcelib(this.query).then(res => {
                this.list = res.rows
                this.total = res.total
                this.loading = false
            })
        }
    }
}
</script>

<style scoped>
.resourceLib{
    width: 1500px;
    margin: 0 auto;
    box-sizing: border-box;
    border-top: 1px solid #00000010;
    display: flex;
    justify-content: space-between;
}
.resourceLib-filter{
    width: 268px;
    box-sizing: border-box;
    border-right: 1px solid #00000010;
    padding-top: 40px;
    display: flex;
    flex-direction: column;
}
.resourceLib-filter-title{
    font-weight: bold;
    font-size: 24px;
    color: #1C8577;
    margin-bottom: 15px;
}
.resourceLib-filter-box{
    display: flex;
    flex-direction: column;
}
.resourceLib-filter-box p{
    font-weight: bold;
    font-size: 20px;
    color: #333;
    margin-top: 40px;
}
.resourceLib-filter-box div{
    width: 212px;
    height: 46px;
    background: transparent;
    font-size: 20px;
    line-height: 44px;
    text-align: center;
    border: 1px solid #666 !important;
    margin-top: 16px;
    transition: all 0.3s;
    color: #333;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    box-sizing: border-box;
}
.resourceLib-filter-box div:hover{
    background: linear-gradient(to right, #18676A 0%, #18676A 10%, #1C8577 10%, #1C8577 100%) !important;
    border: 1px solid transparent !important;
    color: #fff !important;
}
.resourceLib-box{
    width: 1168px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 119px 0 75px;
}
.resourceLib-box-item{
    width: 100%;
    height: 160px;
    border-radius: 8px;
    background: #fff;
    margin-bottom: 20px;
    box-sizing: border-box;
    padding: 25px 47px 29px 28px;
    display: flex;
    justify-content: space-between;
}
.resourceLib-box-item:hover{
    transition: all 0.3s;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    transform: translateY(-5px);
}
.resourceLib-box-item-left{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.resourceLib-box-item-left-title{
    font-weight: bold;
    width: 640px;
    min-height: 28px;
    font-size: 20px;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.resourceLib-box-item-left div{
    width: 640px;
    min-height: 0;
    max-height: 50px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex-wrap: wrap;
}
.resourceLib-box-item-left div p{
    width: 300px;
    min-height: 24px;
    font-size: 16px;
    color: #666;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.resourceLib-box-item-right{
    display: flex;
    flex-direction: column;
}
.resourceLib-box-item-right p{
    display: flex;
    color: #EEA634;
    font-size: 16px;
    b{
        font-size: 14px;
        font-weight: lighter;
        margin-left: 10px;
    }
}
.resourceLib-box-item-right a{
    width: 108px;
    height: 42px;
    border-radius: 4px;
    background-color: #1c8577;
    color: #fff;
    text-align: center;
    line-height: 42px;
    font-size: 18px;
    margin: 16px 0;
    cursor: pointer;
    transition: all 0.3s;
}
.resourceLib-box-item-right a:hover{
    opacity: 0.8;
}
.resourceLib-box-item-right a:active{
    opacity: 0.5;
}
.resourceLib-box-item-right span{
    font-size: 14px;
    color: #999;
}
.pagination{
    margin-top: 37px;
}
::v-deep .pagination .btn-prev,  ::v-deep .pagination .btn-next {
    min-width: 32px !important;
    height: 32px !important;
    color: #1C8577 !important;
    background-color: #fff !important;
}
::v-deep .pagination .number, ::v-deep .pagination .el-icon-more, ::v-deep .pagination .el-icon-d-arrow-right, ::v-deep .pagination .el-icon-d-arrow-left {
    min-width: 32px !important;
    height: 32px !important;
    color: #1C8577 !important;
    line-height: 32px !important;
    background-color: #fff !important;
}
::v-deep .pagination .active {
    color: #ffffff !important;
    background-color: #1C8577 !important;
}
</style>